import styled from 'styled-components';
import { ReactComponent as LogoIcon } from '../../assets/icons/logo.svg';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: #111112;
  z-index: 999;

  @media (min-width: 761px) {
    background: rgba(3, 5, 9, 0.62);
    backdrop-filter: blur(28px);
  }
`;

export const OverlayContent = styled.div`
  height: 100%;
  width: 100%;
  padding: ${({ $top, $bottom }) => `${Math.max($top, 0)}px 0 ${Math.max($bottom, 0)}px`};
  display: flex;
  flex-direction: column;

  @media (min-width: 761px) {
    padding: ${({ $top, $bottom }) => `${Math.max($top, 16)}px 2.4rem ${Math.max($bottom, 16)}px`};
  }
`;

export const OverlayMobileHeader = styled.div`
  height: 4.6rem;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 761px) {
    display: none;
  }
`;

export const OverlayHeader = styled.div`
  display: none;

  @media (min-width: 761px) {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    min-height: 4.8rem;
  }
`;

export const FeedViewport = styled.div`
  flex: 1;
  min-height: 0;

  @media (min-width: 761px) {
    display: flex;
    justify-content: center;
  }
`;

export const FeedStage = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  overflow: hidden;
  background: #101010;

  @media (min-width: 761px) {
    width: min(100%, 55rem);
    border-radius: 1.2rem;
    box-shadow: 0 24px 70px rgba(0, 0, 0, 0.35);
  }
`;

const BlurBand = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  height: 6.5rem;
  z-index: 3;
  pointer-events: none;

  @media (min-width: 761px) {
    display: none;
  }
`;

export const TopBlur = styled(BlurBand)`
  top: 0;
  background: linear-gradient(
    to bottom,
    #111112 0%,
    rgba(17, 17, 18, 0.738) 19%,
    rgba(17, 17, 18, 0.541) 34%,
    rgba(17, 17, 18, 0.382) 47%,
    rgba(17, 17, 18, 0.278) 56.5%,
    rgba(17, 17, 18, 0.194) 65%,
    rgba(17, 17, 18, 0.126) 73%,
    rgba(17, 17, 18, 0.075) 80.2%,
    rgba(17, 17, 18, 0.042) 86.1%,
    rgba(17, 17, 18, 0.021) 91%,
    rgba(17, 17, 18, 0.008) 95.2%,
    rgba(17, 17, 18, 0.002) 98.2%,
    transparent 100%
  );
`;

export const BottomBlur = styled(BlurBand)`
  bottom: 0;
  background: linear-gradient(
    to bottom,
    transparent 0%,
    rgba(17, 17, 18, 0.002) 1.8%,
    rgba(17, 17, 18, 0.008) 4.8%,
    rgba(17, 17, 18, 0.021) 9%,
    rgba(17, 17, 18, 0.042) 13.9%,
    rgba(17, 17, 18, 0.075) 19.8%,
    rgba(17, 17, 18, 0.126) 27%,
    rgba(17, 17, 18, 0.194) 35%,
    rgba(17, 17, 18, 0.278) 43.5%,
    rgba(17, 17, 18, 0.382) 53%,
    rgba(17, 17, 18, 0.541) 66%,
    rgba(17, 17, 18, 0.738) 81%,
    #111112 100%
  );
`;

export const StyledLogo = styled(LogoIcon)`
  opacity: 0.8;

  @media (min-width: 761px) {
    justify-self: center;
  }
`;

const HeaderActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.8rem;
  width: fit-content;
  padding: 0;
  border: none;
  background: transparent;
  color: #fff;
  font-size: 1.5rem;
  font-weight: 400;
  letter-spacing: -0.075px;
  opacity: 0.5;
  cursor: pointer;
`;

export const HeaderBackButton = styled(HeaderActionButton)`
  justify-self: start;

  svg {
    width: 2.4rem;
    height: 2.4rem;
    transform: rotate(180deg);
  }
`;
